import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the Location EC: display = Name, value = USID. Locations nest, and the
// picker draws them as an indented tree rather than a flat list -- a source with a database holding
// several schemas is otherwise indistinguishable from a source with several unrelated ones.
class LocationPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "Location";
        this.static = false;
        this.enterpriseComponent = "Location";
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = true;
        this.allowNoSelectionDisplayValue = "None";
        this.hierarchical = true;
        // Each option's parent, read from the buffer and resolved to the parent option's value.
        this.hierarchyParentField = "ParentUSID";
        // A location's own name is not enough to place it -- "PUBLIC" under two databases is two
        // different locations -- so the type is appended to tell them apart.
        this.secondaryDisplayField = "LocationType";
    }
}

export default LocationPicklistMetadata;
